"use client";

import { UspsSection } from "@/components/sections/usps";
import { usps } from "@/lib/data/services-competitive-intelligence";

export function Usps() {
  return (
    <UspsSection
      eyebrow={usps.eyebrow}
      title={usps.title}
      intro={usps.intro}
      accent={usps.accent}
      gridCols={usps.gridCols}
      usps={usps.usps}
      cta={usps.cta}
    />
  );
}